import React from "react";
import Helmet from "react-helmet";
import { Link } from "@reach/router";

import Navigation from "../../components/WaveNavigation";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Private Charters"
      meta={[
        {
          name: "description",
          content: "Fire Island Ferries Private Charters",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h2>Info</h2>
            <h1>Private Charters</h1>
          </div>
          <p>
            For Information Regarding Private Charters, please call us at{" "}
            <span className="text-nowrap">
              <i className="far fa-phone" /> 631.665.3600
            </span>{" "}
            or e-mail us at{" "}
            <span className="text-nowrap">
              <i className="far fa-envelope" /> info@fireislandferries.com
            </span>
          </p>
          <p>Available Services Include Transportation to Fire Island for:</p>
          <ul>
            <li>School Field Trips</li>
            <li>Weddings</li>
            <li>Bar/Bat Mitzvas</li>
            <li>Memorial Ceremonies</li>
            <li>And Much More...</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);
